import { render } from "./PasswordResetHeaderModal.vue?vue&type=template&id=229e14f0&scoped=true"
import script from "./PasswordResetHeaderModal.vue?vue&type=script&lang=js"
export * from "./PasswordResetHeaderModal.vue?vue&type=script&lang=js"

import "./PasswordResetHeaderModal.vue?vue&type=style&index=0&id=229e14f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229e14f0"]])

export default __exports__